import styled, { css } from 'styled-components'
import { borderRadius } from '../_styles/borderRadius'
import { colors } from '../_styles/colors'
import { getShadow } from '../_styles/shadows'
import type { Placement } from '../_utils/placement'

export const popoverArrowSize = 6

interface StyledPopoverProps {
  $block: boolean
  $fluid: boolean
  $placement: Placement
}

export const StyledPopoverContent = styled.span<StyledPopoverProps>`
  background-color: ${colors.white};
  border-radius: inherit;

  color: ${colors.gray15};
  display: inline-block;
  max-width: 250px;
  position: relative;

  ${({ $block, $fluid }) => {
    if ($block || $fluid) {
      return css`
        max-width: none;
      `
    }
  }}
`

export const StyledPopover = styled.div`
  display: inline-block;
  border-radius: ${borderRadius.md}px;
  ${getShadow(3)}

  & + [data-overlay-arrow] {
    background: ${colors.white};
  }
`
